import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoginCallbackComponent } from '@vinnova/auth';
import { ErrorComponent, NotFoundComponent } from '@vinnova/e-tjanster';
import { featureFlagGuard } from '@vinnova/feature-toggling';
import { LayoutComponent } from './layout/layout.component';
import { PdfLoadingComponent } from './pdf-loading/pdf-loading.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canMatch: [featureFlagGuard('ShowProject')],
    loadChildren: () =>
      import('./features/projekt-list/projekt-list.module').then(
        (m) => m.ProjektListModule,
      ),
  },
  {
    path: 'projekt',
    component: LayoutComponent,
    canMatch: [featureFlagGuard('ShowProject')],
    loadChildren: () =>
      import('./features/projekt/projekt.module').then((m) => m.ProjektModule),
  },
  {
    path: 'rapport',
    component: LayoutComponent,
    loadChildren: () =>
      import('./features/rapport/rapport.module').then((m) => m.RapportModule),
  },
  {
    path: 'begaran',
    component: LayoutComponent,
    loadChildren: () =>
      import('./features/begaran/begaran.module').then((m) => m.BegaranModule),
  },
  {
    path: 'login-callback',
    component: LoginCallbackComponent,
  },
  {
    path: 'pdf-loading',
    component: PdfLoadingComponent,
  },
  {
    path: 'not-found',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: NotFoundComponent,
      },
    ],
  },
  {
    path: 'error',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: ErrorComponent,
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
